import ScoreByDeviceAndDateWidget from './ScoreByDeviceAndDateWidget';
export default ScoreByDeviceAndDateWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/ScoreByDeviceAndDateWidget/index.js